"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactCollapse = require("react-collapse");

var _reactSpring = require("react-spring");

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Icon = function Icon(_ref) {
  var component = _ref.component;
  return component ? (0, _react.cloneElement)(component, {
    width: 20,
    height: 20
  }) : null;
};

var Accordion = function Accordion(_ref2) {
  var children = _ref2.children,
      colorType = _ref2.colorType,
      _isOpen = _ref2.isOpen,
      _trigger = _ref2.trigger,
      triggerProps = _ref2.triggerProps,
      bodyProps = _ref2.bodyProps,
      title = _ref2.title,
      onOpen = _ref2.onOpen,
      onClose = _ref2.onClose,
      lazyLoad = _ref2.lazyLoad,
      rest = _objectWithoutProperties(_ref2, ["children", "colorType", "isOpen", "trigger", "triggerProps", "bodyProps", "title", "onOpen", "onClose", "lazyLoad"]);

  var _useState = (0, _react.useState)(_isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var CollapseComponent = lazyLoad ? _reactCollapse.UnmountClosed : _reactCollapse.Collapse;
  (0, _react.useEffect)(function () {
    if (isOpen) {
      onOpen();
    } else if (!isOpen) {
      onClose();
    }
  }, [isOpen]);
  var transitions = (0, _reactSpring.useTransition)(isOpen, {
    from: {
      position: 'absolute',
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    reverse: isOpen,
    delay: 200,
    config: _reactSpring.config.wobbly
  });

  var iconTransitions = function iconTransitions(iconComponent, iconComponentOpen) {
    return transitions(function (_ref3, isOpenT) {
      var opacity = _ref3.opacity;
      return isOpenT ? /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
        style: {
          position: 'absolute',
          opacity: opacity.to({
            range: [0.0, 1.0],
            output: [0, 1]
          })
        }
      }, /*#__PURE__*/_react["default"].createElement(Icon, {
        component: iconComponentOpen
      })) : /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
        style: {
          position: 'absolute',
          opacity: opacity.to({
            range: [1.0, 0.0],
            output: [1, 0]
          })
        }
      }, /*#__PURE__*/_react["default"].createElement(Icon, {
        component: iconComponent
      }));
    });
  };

  var icon = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_styles.IconWrapper, null, iconTransitions(triggerProps.icon, triggerProps.iconOpen));
  }, [isOpen, triggerProps.iconOpen, triggerProps.icon]);
  var iconRight = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_styles.IconWrapper, null, iconTransitions(triggerProps.iconRight, triggerProps.iconRightOpen));
  }, [isOpen, triggerProps.iconRightOpen, triggerProps.iconRight]);

  var handleTrigger = function handleTrigger() {
    setIsOpen(!isOpen);
  };

  if (!_trigger) {
    _trigger = /*#__PURE__*/_react["default"].createElement(_styles.Trigger, _extends({
      colorType: colorType,
      noMargin: true,
      arrowStyle: {
        transition: 'transform 300ms',
        transform: "rotate(".concat(isOpen ? '-' : '', "90deg)")
      }
    }, triggerProps, {
      icon: icon,
      iconRight: iconRight
    }), title);
  }

  var trigger = (0, _react.cloneElement)(_trigger, {
    onClick: handleTrigger
  });
  return /*#__PURE__*/_react["default"].createElement(_styles.Wrapper, _extends({
    colorType: colorType
  }, rest), trigger, /*#__PURE__*/_react["default"].createElement(CollapseComponent, {
    isOpened: isOpen
  }, /*#__PURE__*/_react["default"].createElement(_styles.Body, _extends({
    colorType: colorType,
    isOpen: isOpen
  }, bodyProps), children)));
};

Accordion.propTypes = {
  trigger: _propTypes["default"].node,
  triggerProps: _propTypes["default"].object,
  bodyProps: _propTypes["default"].object,
  children: _propTypes["default"].node,
  title: _propTypes["default"].node,
  colorType: _propTypes["default"].object,
  isOpen: _propTypes["default"].bool,
  lazyLoad: _propTypes["default"].bool,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func
};
Accordion.defaultProps = {
  isOpen: false,
  lazyLoad: false,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  triggerProps: {}
};
var _default = Accordion;
exports["default"] = _default;